/**
 * Helper: Timing
 * -----------------------------------------------------------------------------
 * Retrieve timing from timings file.
 *
 * @param {String} timing - Timing to retrieve.
 * @param {Object} [options] - Options object.
 * @param {Number} [options.index] - Forloop index to multiply timing by.
 * @param {Boolean} [options.printUnit] - Print unit at end of time, passing a
 * number to index automatically prints the unit.
 * @param {String} [options.unit] - Unit to return timing in, `ms` or `s`.
 * @returns {Number|String}
 *
 */
import timings from '~/config/timings'

export default (timing, { index, printUnit, unit = 'ms' } = {}) => {
  let time = timings[timing]

  if (!time) {
    return 0
  }

  if (unit === 's') {
    time /= 1000
  }

  if (typeof index === 'number') {
    time *= index
  }

  if (
    printUnit ||
    (typeof index === 'number' && typeof printUnit === 'undefined')
  ) {
    time = `${time}${unit}`
  }

  return time
}
